import { createWebHashHistory, createRouter } from "vue-router";
import login from "@/pages/login/login.vue";
import forgotPassword from "@/components/forgotpassword.vue";
import newPassword from "@/components/newpassword.vue";
import IOT from "@/pages/dashboard/iot/iot.vue";
import iotTab2 from "@/pages/dashboard/iot/tab-2/iot-tab-2.vue";
import alarmAll from "@/pages/dashboard/alarm/all.vue";
import alarmHardware from "@/pages/dashboard/alarm/hardware.vue";
import alarmComponent from "@/pages/dashboard/alarm/component.vue"
import alarmProcess from "@/pages/dashboard/alarm/process.vue";
import Reports from "@/pages/dashboard/reports.vue";
import lakehouse from "@/pages/dashboard/lakehouse/lakehouse.vue";
import temp from "@/pages/dashboard/lakehouse/temp.vue";
import assetType from "@/pages/iot-assets/asset-type/asset-type.vue"
import assetTypeForm from "@/pages/iot-assets/asset-type/asset-type-form.vue"
import asset from "@/pages/iot-assets/asset/asset.vue"
import assetForm from "@/pages/iot-assets/asset/asset-form.vue";
import assetList from "@/pages/iot-assets/asset-list/asset-list.vue";
import assetListForm from "@/pages/iot-assets/asset-list/asset-list-form.vue";
import network from "@/pages/iot-assets/network/network.vue"
import networkForm from "@/pages/iot-assets/network/network-form.vue";
import networkType from "@/pages/iot-assets/network-type/network-type.vue";
import networkTypeForm from "@/pages/iot-assets/network-type/network-type-form.vue";
import component from "@/pages/hub-sensor/component/component.vue"
import componentForm from "@/pages/hub-sensor/component/component-form.vue";
import componentType from "@/pages/hub-sensor/component-type/component-type.vue";
import componentTypeForm from "@/pages/hub-sensor/component-type/component-type-form.vue";
import device from "@/pages/hub-sensor/device/device.vue";
import deviceForm from "@/pages/hub-sensor/device/device-form.vue";
import deviceType from "@/pages/hub-sensor/device-type/device-type.vue";
import deviceTypeForm from "@/pages/hub-sensor/device-type/device-type-form.vue";
import iotHub from "@/pages/hub-sensor/iot-hub/iot-hub.vue";
import iotHubForm from "@/pages/hub-sensor/iot-hub/iot-hub-form.vue";
import os from "@/pages/hub-sensor/os/os.vue";
import osForm from "@/pages/hub-sensor/os/os-form.vue";
import roleType from "@/pages/user-management/role-type/role-type.vue";
import roleTypeForm from "@/pages/user-management/role-type/role-type-form.vue";
import role from "@/pages/user-management/role/role.vue";
import userList from "@/pages/user-management/user-list/user-list.vue";
import userListForm from "@/pages/user-management/user-list/user-list-form.vue";
import roleForm from "@/pages/user-management/role/role-form.vue";
import userType from "@/pages/user-management/user-type/user-type.vue";
import userTypeForm from "@/pages/user-management/user-type/user-type-form.vue";
import user from "@/pages/user-management/user/user.vue";
import userForm from "@/pages/user-management/user/user-form.vue";
import remoteOps from "@/pages/remote-ops/controller/controller.vue";
import remoteOpsForm from "@/pages/remote-ops/controller/controller-form.vue";
import sensorType from "@/pages/iot-sensors/sensor-type/sensor-type.vue";
import sensorTypeForm from "@/pages/iot-sensors/sensor-type/sensor-type-form.vue";
import sensor from "@/pages/iot-sensors/sensor/sensor.vue"
import sensorForm from "@/pages/iot-sensors/sensor/sensor-form.vue";
import archivalHistory from "@/pages/archival/archival-history/archival-history.vue";
import exportData from "@/pages/archival/export-data/export-data.vue";
import deviceGraph from "@/pages/archival/device-graph/device-graph.vue";
import listData from "@/pages/archival/list-data/list-data.vue";
import trashScan from "@/pages/archival/trash-scan/trash-scan.vue";

const routes= [
    {
        path: "",
        redirect: "/login",
    },
    {
        path: "/login",
        component: login,
        meta: { withoutLayout: true }
    },
    {
        path: "/forgot-password",
        component: forgotPassword,
        meta: { withoutLayout: true }
    },
    {
        path: "/reset-password",
        component: newPassword,
        meta: { withoutLayout: true }
    },
    // Dashboard
    {
        path: '/',  // Define the default route
        redirect: '/dashboard/sensor/overview'  // Redirect to the desired path
    },
    {
        path: '/dashboard/device/analytics',
        component: IOT,
    },
    {
        path: '/dashboard/sensor/overview',
        component: iotTab2
    },
    {
        path: '/dashboard/alarm/all',
        component: alarmAll
    },
    {
        path: '/dashboard/alarm/hardware',
        component: alarmHardware
    },
    {
        path: '/dashboard/alarm/component',
        component: alarmComponent
    },
    {
        path: '/dashboard/alarm/process',
        component: alarmProcess
    },
    {
        path: '/dashboard/reports',
        component: Reports
    },
    {
        path: '/dashboard/lake/house',
        component: lakehouse
    },
    {
        path: '/dashboard/temp/lake/house',
        component: temp
    },
    // IoT Assets
    {
        path: '/iotassets/assettype',
        component: assetType
    },
    {
        path: '/iotassets/assettype/add',
        component: assetTypeForm
    },
    {
        path: '/iotassets/assettype/edit/:id',
        component: assetTypeForm
    },
    {
        path: '/iotassets/asset',
        component: asset
    },
    {
        path: '/iotassets/asset/add',
        component: assetForm
    },
    {
        path: '/iotassets/asset/edit/:id',
        component: assetForm
    },
    {
        path: '/iotassets/assetlist',
        component: assetList
    },
    {
        path: '/iotassets/assetlist/add',
        component: assetListForm
    },
    {
        path: '/iotassets/assetlist/edit/:id',
        component: assetListForm
    },
    {
        path: '/iotassets/network',
        component: network
    },
    {
        path: '/iotassets/network/add',
        component: networkForm
    },
    {
        path: '/iotassets/network/edit/:id',
        component: networkForm
    },
    {
        path: '/iotassets/networktype',
        component: networkType
    },
    {
        path: '/iotassets/networktype/add',
        component: networkTypeForm
    },
    {
        path: '/iotassets/networktype/edit/:id',
        component: networkTypeForm
    },
    // Hub and Sensor
    {
        path: '/hubsensors/component',
        component: component
    },
    {
        path: '/hubsensors/component/add',
        component: componentForm
    },
    {
        path: '/hubsensors/component/edit/:id',
        component: componentForm
    },
    {
        path: '/hubsensors/componenttype',
        component: componentType
    },
    {
        path: '/hubsensors/componenttype/add',
        component: componentTypeForm
    },
    {
        path: '/hubsensors/componenttype/edit/:id',
        component: componentTypeForm
    },
    {
        path: '/hubsensors/device',
        component: device
    },
    {
        path: '/hubsensors/device/add',
        component: deviceForm
    },
    {
        path: '/hubsensors/device/edit/:id',
        component: deviceForm
    },
    {
        path: '/hubsensors/devicetype',
        component: deviceType
    },
    {
        path: '/hubsensors/devicetype/add',
        component: deviceTypeForm
    },
    {
        path: '/hubsensors/devicetype/edit/:id',
        component: deviceTypeForm
    },
    {
        path: '/hubsensors/iothub',
        component: iotHub
    },
    {
        path: '/hubsensors/iothub/add',
        component: iotHubForm
    },
    {
        path: '/hubsensors/iothub/edit/:id',
        component: iotHubForm
    },
    {
        path: '/hubsensors/os',
        component: os
    },
    {
        path: '/hubsensors/os/add',
        component: osForm
    },
    {
        path: '/hubsensors/os/edit/:id',
        component: osForm
    },
    
    // IoT Sensors
    {
        path: '/iotsensors/sensortype',
        component: sensorType
    },
    {
        path: '/iotsensors/sensortype/add',
        component: sensorTypeForm
    },
    {
        path: '/iotsensors/sensortype/edit/:id',
        component: sensorTypeForm
    },
    {
        path: '/iotsensors/sensor',
        component: sensor
    },
    {
        path: '/iotsensors/sensor/add',
        component: sensorForm
    },
    {
        path: '/iotsensors/sensor/edit/:id',
        component: sensorForm
    },
    // User Management
    {
        path: '/usermanagement/roletype',
        component: roleType
    },
    {
        path: '/usermanagement/roletype/add',
        component: roleTypeForm
    },
    {
        path: '/usermanagement/roletype/edit/:id',
        component: roleTypeForm
    },
    {
        path: '/usermanagement/role',
        component: role
    },
    {
        path: '/usermanagement/role/add',
        component: roleForm
    },
    {
        path: '/usermanagement/role/edit/:id',
        component: roleForm
    },
    {
        path: '/usermanagement/userlist',
        component: userList
    },
    {
        path: '/usermanagement/userlist/add',
        component: userListForm
    },
    {
        path: '/usermanagement/userlist/edit/:id',
        component: userListForm
    },
    {
        path: '/usermanagement/usertype',
        component: userType
    },
    {
        path: '/usermanagement/usertype/add',
        component: userTypeForm
    },
    {
        path: '/usermanagement/usertype/edit/:id',
        component: userTypeForm
    },
    {
        path: '/usermanagement/user',
        component: user
    },
    {
        path: '/usermanagement/user/add',
        component: userForm
    },
    {
        path: '/usermanagement/user/edit/:id',
        component: userForm
    },
    // Remote Ops
    {
        path: '/remoteops/controller',
        component: remoteOps
    },
    {
        path: '/remoteops/controller/view/:id',
        component: remoteOpsForm
    },
    // Archival
    {
        path: '/archival/history',
        component: archivalHistory
    },
    {
        path: '/archival/exportdata',
        component: exportData
    },
    {
        path: '/archival/devicegraph',
        component: deviceGraph
    },
    {
        path: '/archival/listdata',
        component: listData
    },
    {
        path: '/archival/trashscan',
        component: trashScan
    },
];


const router=createRouter({
    history: createWebHashHistory(),
    routes
})
export default router;